import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Card, CardBody, Badge } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";

const LoyaltyAndGuestPreferences = ({ booking, hotelConfig }) => {
  const getGuestPreferences = () => {
    const { preferences } = booking;
    if (preferences) {
      const guestPreferencesIsSelected = preferences.filter(res => res.is_selected === true);
      if (guestPreferencesIsSelected.length === 0) {
        return ("No guest preferences");
      } else {
        return guestPreferencesIsSelected.map((res, index) => <p key={res.id}>{res.name.en}</p>);
      }
    }
  }

  // Burayı satırı hiçbir şekilde silme
  if (!hotelConfig.loyaltyAndguestPreferences) return (<></>)

  return (
    <Card className="mb-4 mt-4 text-center">
      <CardBody>
        <h3 className="list-item-heading mb-2">
          <IntlMessages id="bookingDetails.Loyalty_and_preferences" />
        </h3>

        <div className="separator mb-2 mt-1" />

        <div>
          <div className="text-muted float-left w-100 mb-1">
            <IntlMessages id="bookingDetails.loyalty_point" />
          </div>

          <div className="w-100 float-right mb-4">
            <Badge color="success" pill className="mb-1">
              {booking.loyalty_point ? booking.loyalty_point : "0"}
            </Badge>
          </div>

          <div className="text-muted float-left w-100 mb-1">
            <IntlMessages id="bookingDetails.guest_preferences" />
          </div>

          <div className="w-100 float-right">
            {booking.preferences ? getGuestPreferences() : "No guest preferences"}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = ({ settings }) => {
  const { hotelConfig } = settings;
  return { hotelConfig };
};

const mapActionsToProps = {
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(LoyaltyAndGuestPreferences)
);
